import { Component, OnDestroy, OnInit } from '@angular/core';

import { RoutingService, TranslatePipe } from '@spartacus/core';
import { UserAccountService } from '@spartacus/user/account/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { CartQuoteSummary } from 'src/app/models/cart-quote-summary.model';
import { KnBrCartQuoteSummaryService } from 'src/app/services/kn-br-cart-quote.service';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-cart-quote-summary',
    templateUrl: './kn-br-cart-quote-summary.component.html',
    styleUrls: ['./kn-br-cart-quote-summary.component.scss'],
    imports: [AsyncPipe, TranslatePipe]
})
export class KnBrCartQuoteSummaryComponent implements OnInit, OnDestroy {
  openCartsCount$: Observable<CartQuoteSummary[]>;
  cartsValue$: Observable<CartQuoteSummary[]>;
  quotesCount$: Observable<CartQuoteSummary[]>;
  quotesValue$: Observable<CartQuoteSummary[]>;
  subscription: Subscription;

  constructor(
    protected cartQuoteSummaryService: KnBrCartQuoteSummaryService,
    protected routingService: RoutingService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected userService: UserAccountService
  ) {
    this.openCartsCount$ = this.cartQuoteSummaryService.loadCartsCounter();
    this.cartsValue$ = this.cartQuoteSummaryService.loadCartsValue();
    this.quotesCount$ = this.cartQuoteSummaryService.loadQuotesCounter();
    this.quotesValue$ = this.cartQuoteSummaryService.loadQuotesValue();
  }

  ngOnInit() {
    combineLatest([this.userService.get(), this.knBrCustomerContextService.getActiveCustomerNumber()]).subscribe(
      ([user, customerNumber]) => {
        if ((user && user.roles && !user.roles?.includes('bravaNSMgroup')) || (user && user.roles === undefined)) {
          this.cartQuoteSummaryService.getCartsCounter(customerNumber);
          this.cartQuoteSummaryService.getCartsValue(customerNumber);
          this.cartQuoteSummaryService.getQuotesCounter(customerNumber);
          this.cartQuoteSummaryService.getQuotesValue(customerNumber);
        }
      }
    );
  }

  navigate(url: string) {
    this.routingService.goByUrl(url);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.cartQuoteSummaryService.cartsCounterResult$.next(null);
    this.cartQuoteSummaryService.cartsValueResult$.next(null);
    this.cartQuoteSummaryService.quotesCounterResult$.next(null);
    this.cartQuoteSummaryService.quotesValueResult$.next(null);
  }
}
